import { createStyles, makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      minHeight: 400,
      width: '100%',
      backgroundColor: '#ebebeb',
      padding: 0,
      borderRadius: 10,
      alignContent: 'center'
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1)
    },
    titleText: {
      textAlign: 'justify',
      color: theme.palette.text.secondary,
      textIndent: theme.spacing(1)
    },
    gridInputText: {
      padding: '10px'
    }
  })
)
